<template>
  <div class="brainsmap-container">
    <div id="viewDiv" style="height: 100%" />
    <div v-if="loading" class="brains-map-loader" />
    <div v-if="usedTypos.length > 0 && activeNav === 'portfolio'" class="portfolio-typo-legend">
      <brainsSelector
        v-model="colorByProperty"
        :placeholder="$t('portfoliosSelector.select-portfolio') + '*'"
        :list="allowedColorCategories"
        :list-key="'brainsId'"
        :list-label="'clientTitle'"
      />
      <!-- <div class="portfolio-typo-legend--title">{{ $t('typology-legend') }}</div> -->
      <hr style="width: 100%; margin-left: -4px; border: 1px solid #d8af46; margin-right: auto; background-color: #d8af46">
      <div class="portfolio-typo-legend--content">
        <div v-for="item in usedTypos" :key="item.typo" class="portfolio-typo-legend--row">
          <div class="legendcoloritem" :style="{ 'background-color': 'rgb(' + item.color[0] + ',' + item.color[1] + ',' + item.color[2] + ')' }" />
          <div class="legendlabelitem">{{ item.typo }}</div>
        </div>
      </div>
    </div>
    <div class="legendcontrol">
      <div class="btn-legend-map" @click="exportMapAsPNG()">
        <font-awesome-icon class="btn-savemap-btn" icon="save" />
      </div>
      <div id="poly_container" class="poly_container" />
      <div v-if="activelegend" class="popover-legend" width="200">
        <i class="el-icon-close iconclosebrains" aria-hidden="true" @click="activelegend = false" />
        <div class="container-legend">
          <div class="sub-title-legend">{{ legendtitle }} {{ typolegend }}</div>
          <hr style="width: 100%; margin-left: -4px; border: 1px solid #1e3cff; margin-right: auto; background-color: #1e3cff">
          <div class="sub-title-legend">{{ legendlevel }} ({{ mapLevelDate }})</div>
          <div v-for="item in legendstops" :key="item.label" class="legenditemcontainer">
            <div :style="{ 'background-color': item.color }" class="legendcoloritem" />
            <div class="legendlabelitem">{{ item.label }} {{ item.unit }}</div>
          </div>
        </div>
      </div>
      <!--  -->

      <div slot="reference" class="btn-legend-map" @click="activelegend = !activelegend">
        <img v-if="activelegend" :alt="$t('maps.map-type')" src="@/assets/brains_icons/leyenda.png" width="19" height="19">
        <img v-else :alt="$t('maps.map-type')" src="@/assets/brains_icons/leyendagrey.png" width="19" height="19">
      </div>

      <!--  -->

      <div slot="reference" class="btn-legend-map btn-gsv" @mouseover="gsv_active = true" @mouseleave="gsv_active = false">
        <img v-if="!gsv_active" :alt="$t('maps.street-view')" src="@/assets/brains_icons/streetview.png" width="19" height="19">
        <img v-else src="@/assets/brains_icons/streetviewgold.png" width="50" height="50" draggable="true" alt="image">
      </div>

      <!--  -->
      <el-popover v-model="map_type_popover" :visible-arrow="false" placement="left" width="60">
        <div class="container-basemap-selector">
          <div
            :class="{ 'basemap-active': basemapValue === 'topo-vector' }"
            :title="$t('maps.change-topo-view')"
            class="btn-selector-basemap--topo"
            @click="cambiarBasemap('topo-vector')"
          >
            <span class="btn-selector-basemap--texto">{{ $t("maps.topographic") }}</span>
          </div>
          <div
            :class="{ 'basemap-active': basemapValue === 'satellite' }"
            :title="$t('mapschange-satellite-view')"
            class="btn-selector-basemap--satellite"
            @click="cambiarBasemap('satellite')"
          >
            <span class="btn-selector-basemap--texto">{{ $t("maps.change-satellite-view") }}</span>
          </div>
        </div>
        <div slot="reference" class="btn-legend-map">
          <img v-if="map_type_popover" :alt="$t('maps.map-type')" src="@/assets/brains_icons/satellitegold.png" width="19" height="19">
          <img v-else :alt="$t('maps.map-type')" src="@/assets/brains_icons/satellitegrey.png" width="19" height="19">
        </div>
      </el-popover>
      <div v-if="lockablemap" class="btn-legend-map" @click="lockmapzoom()">
        <font-awesome-icon v-if="maplocked" class="btn-savemap-btn" icon="lock" />
        <font-awesome-icon v-else class="btn-savemap-btn" icon="lock-open" />
      </div>
    </div>
  </div>
</template>
<script>
import basemap from '@/components/mixins/basemap'
import brainsSelector from '@/components/designComponents/brainsAutocomplete'
import { mapState } from 'vuex'
export default {
  name: 'BrainsMap',
  components: { brainsSelector },
  mixins: [basemap],
  computed: {
    ...mapState('user', {
      activeNav: (state) => state.activeNav
    })
  }
}
</script>

<style lang="scss">
.poly_container {
  width: 32px;
  margin-top: 8px;
  .esri-sketch__tool-section {
    display: flex;
    flex-direction: column;
  }
}
.portfolio-typo-legend {
  position: absolute;
  width: 200px;
  right: 5px;
  bottom: 5px;
  background-color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  padding: 15px;
  font-family: 'Montserrat-Regular',sans-serif;
  font-size: 13px;

  &--title {
    font-family: 'Montserrat-SemiBold',sans-serif;
    font-size: 14px;
  }

  &--row {
    display: flex;
    align-items: center;
  }
}

</style>

<style lang="scss" scoped>
.brainsmap-container {
  height: calc(100vh - 110px);
  width: 100%;
  position: relative;
}

div#viewDiv {
  padding: 0;
  margin: 0;
  width: auto;
  height: 100%;
}

.mapcontrols {
  position: absolute;
  top: 10px;
  left: 5px;
}

.el-collapse-item__arrow {
  display: none;
}

.legendcontrol {
  position: absolute;
  bottom: 100px;
  left: 15px;
}

.mapfilters_integrated {
  position: absolute;
  top: 35px;
  right: 10px;
}

.locationdetails {
  font-family: "Montserrat-Regular",sans-serif;
  font-size: 13px;
  display: flex;
  position: absolute;
  top: 0px;
  width: 100%;
  background-color: white;
  opacity: 0.6;
  padding: 7px;

  .pullright {
    margin-right: 0;
    margin-left: auto;
  }
}

.sub-title {
  font-family: "Montserrat-SemiBold",sans-serif;
}

.sub-title-legend {
  text-align: left;
  margin-left: 15px;
  font-weight: bold;
  color: rgb(90, 90, 90);
  margin-bottom: 7px;
  width: 100%;
}

.legendcoloritem {
  height: 25px;
  width: 25px;
  margin: 2px;
  margin-right: 7px;
  opacity: 0.7;
  border: 1px solid black;
}

.legenditemcontainer {
  display: inline-flex;
  transform: scale(0.9);
  align-items: center;
  color: rgb(102, 101, 101);
}

.filterlayerviewer {
  position: absolute;
  top: 5px;
  left: 5px;
  max-width: 250px;
  max-height: 400px;
  background-color: white;
}

.btn-legend-map {
  height: 32px;
  font-size: 12px;
  width: 32px;
  background-color: white;
  // border: 1px solid black;
  color: #6e6e6e;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: none !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer;
  margin-top: 8px !important;
}

.poly_container .esri-sketch__tool-section {
  display: flex;
  flex-direction: column;
  // width: 32px;
  // background-color: white;
  // display: flex;
  // flex-direction: column;
  // text-align: center;
  // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

  // .poly_selector {
  //   padding: 3px;

  //   svg {
  //     padding: 2px;
  //     width: 20px;
  //     height: 20px;
  //     color: #1e3cff;
  //   }
  // }

  // .poly_selector:hover{
  //   background-color: lightgrey;
  //   cursor: pointer;
  // }

  // .poly_selector:active {
  //   background-color: #1e3cff;

  //   svg {
  //     color: white;
  //   }
  // }
}

.container-basemap-selector {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  /* font-size: 14px; */
  gap: 10px;
  justify-content: flex-start;

  .btn-selector-basemap--satellite,
  .btn-selector-basemap--topo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }

  .basemap-active {
    color: #1e3cff;
  }
}

.container-legend {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 5px;
  font-size: 12px;
}

.btn-gsv svg {
  font-size: 19px;
}

.iconclosebrains {
  position: absolute;
  right: 2px;
  top: 2px;
  font-size: 1.1em;
  font-weight: bold;
}
</style>
